import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { SubscriptionCreate } from "../../models/Subscription/SubscriptionCreate";
import { Company } from "../../models/Companies/Company";
import { Software } from "../../models/Softwares/Software";
import agent from "../../../api/agent";
import { checkTokenExpiration } from "../../../api/tokenExpirationChecking";

interface Props {
  closeForm: () => void;
  create: (subscription: SubscriptionCreate) => void;
}

export default function CreateSubscriptionForm({ closeForm, create }: Props) {
  const [subscriptionData, setSubscriptionData] = useState<SubscriptionCreate>({
    status: "Active", // default set to Active value
    startDate: "",
    validDate: "",
    paxNo: 1,
    softwareId: undefined,
    companyId: undefined,
  });

  console.log(subscriptionData.validDate);

  const [companyList, setCompanyList] = useState<Company[]>([]);
  const [softwareList, setSoftwareList] = useState<Software[]>([]);

  // Authentication
  const [token, setToken] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // get the token from localstorage
        const tokenFLocal = localStorage.getItem("token");
        if (tokenFLocal !== null) {
          if (checkTokenExpiration(tokenFLocal)) {
            return;
          }
          setToken(tokenFLocal);
          const companies = await agent.Company.list(tokenFLocal);
          setCompanyList(companies);

          const softwares = await agent.Softwares.list(tokenFLocal);
          setSoftwareList(softwares);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    create(subscriptionData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setSubscriptionData({ ...subscriptionData, [name]: value });
  }

  function handleCompanyNameDropdownOnChange(event: SelectChangeEvent<number>) {
    const value = event.target.value as number;
    setSubscriptionData({ ...subscriptionData, companyId: value });
  }

  function handleSoftwareNameDropdownOnChange(
    event: SelectChangeEvent<number>
  ) {
    const value = event.target.value as number;
    setSubscriptionData({ ...subscriptionData, softwareId: value });
  }

  function handleStatusChange(event: SelectChangeEvent<string>) {
    const { name, value } = event.target;
    setSubscriptionData({ ...subscriptionData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      {/* Company Dropdown */}
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="company-id-label">Company Name</InputLabel>
        <Select
          labelId="company-id-label"
          name="companyId"
          value={subscriptionData.companyId ?? ""} // Empty string if undefined
          onChange={handleCompanyNameDropdownOnChange}
          label="Unit Number"
        >
          {companyList.map((company) => (
            <MenuItem key={company.companyId} value={company.companyId}>
              {company.companyName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Software Dropdown */}
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="software-id-label">Software Name</InputLabel>
        <Select
          labelId="software-id-label"
          name="softwareId"
          value={subscriptionData.softwareId ?? ""} // Empty string if undefined
          onChange={handleSoftwareNameDropdownOnChange}
          label="Software Name"
        >
          {softwareList.map((software) => (
            <MenuItem key={software.softwareId} value={software.softwareId}>
              {software.softwareName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Start Date"
        name="startDate"
        value={subscriptionData.startDate}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        type="date"
        slotProps={{ inputLabel: { shrink: true } }}
      />

      <TextField
        label="Valid Date"
        name="validDate"
        value={subscriptionData.validDate}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        type="date"
        slotProps={{ inputLabel: { shrink: true } }}
      />

      {/* dropdown for status */}
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          name="status"
          value={subscriptionData.status}
          onChange={handleStatusChange}
          label="Status"
        >
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Disable">Disable</MenuItem>
          <MenuItem value="End Service">End Service</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Number of License"
        name="paxNo"
        value={subscriptionData.paxNo}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        type="number"
        required
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Create
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
